"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _helpers = require("@qwkin/helpers");
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _image = require("@qwkin/image");
var _Modal = require("../Modal");
var _DocumentUploader = require("../DocumentUploader/DocumentUploader.styles");
var _Text = _interopRequireDefault(require("../Text/Text"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _ResponsiveImage = require("../ResponsiveImage");
var _ImageUploader = require("./ImageUploader.styles");
var _ImageCropper = require("../ImageCropper");
var _Avatar = require("../Avatar");
var _theme = require("../utils/theme");
var _ImageCameraUploaderModal = _interopRequireDefault(require("./ImageCameraUploaderModal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ImageUploaderModal = function ImageUploaderModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    title = _ref.title,
    _ref$helperText = _ref.helperText,
    helperText = _ref$helperText === void 0 ? 'You can crop your image later to ensure better results.' : _ref$helperText,
    previewRender = _ref.previewRender,
    format = _ref.format,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    _ref$isErasable = _ref.isErasable,
    isErasable = _ref$isErasable === void 0 ? false : _ref$isErasable,
    limitedSizeImage = _ref.limitedSizeImage,
    _ref$oversizeMessage = _ref.oversizeMessage,
    oversizeMessage = _ref$oversizeMessage === void 0 ? 'Exceeded image size.' : _ref$oversizeMessage,
    onComplete = _ref.onComplete,
    src = _ref.src,
    s3Key = _ref.s3Key,
    s3Bucket = _ref.s3Bucket;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    file = _useState2[0],
    setFile = _useState2[1];
  var _useState3 = (0, _react.useState)(src),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    fileSrc = _useState4[0],
    setFileSrc = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    croppedFile = _useState6[0],
    setCroppedFile = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    croppedFileSrc = _useState8[0],
    setCroppedFileSrc = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    imageOversize = _useState10[0],
    setImageOversize = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    isWebCamImageModalVisible = _useState12[0],
    setWebCamImageModalVisibility = _useState12[1];
  var defaultTextColor = imageOversize ? theme.color.danger["default"] : '#333';
  var closeModal = function closeModal() {
    setFile(null);
    setCroppedFile(null);
    onClose();
  };
  var removeImage = function removeImage() {
    onComplete(null, null);
    setFileSrc(null);
    setCroppedFileSrc(null);
    closeModal();
  };
  var completeUpload = function completeUpload() {
    onComplete(croppedFile, croppedFileSrc);
    closeModal();
  };
  (0, _react.useEffect)(function () {
    if (file) {
      (0, _image.fileToDataURL)(file).then(function (src) {
        return setFileSrc("data:".concat(file.type, ";base64,").concat(src));
      });
      setCroppedFile(file);
    } else {
      setFileSrc(src);
    }
  }, [file]);
  (0, _react.useEffect)(function () {
    if (croppedFile) {
      (0, _image.fileToDataURL)(croppedFile).then(function (src) {
        return setCroppedFileSrc("data:".concat(file.type, ";base64,").concat(src));
      });
    } else {
      setCroppedFileSrc(null);
    }
  }, [croppedFile]);
  var handleUploadFileButton = function handleUploadFileButton() {
    var filePicker = document.getElementById('uploadCameraModalInput');
    filePicker.click();
    if (limitedSizeImage) {
      filePicker.onchange = function () {
        if (this.files.length > 0 && this.files[0].size > limitedSizeImage) {
          this.value = '';
          setFile(null);
          setImageOversize(true);
        }
      };
    }
  };
  var saveWebCamImage = function saveWebCamImage(uri) {
    if (uri) {
      var base64 = "data:image/jpeg;base64,".concat(uri);
      setFileSrc(base64);
      fetch(base64).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        var file = new File([blob], 'webcam_picture', {
          type: 'image/jpeg'
        });
        setFile(file);
        setCroppedFile(file);
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Modal.Modal, {
    title: "Change Picture",
    isOpen: isOpen,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_ImageCameraUploaderModal["default"], {
    isOpen: isWebCamImageModalVisible,
    onClose: function onClose() {
      return setWebCamImageModalVisibility(false);
    },
    onComplete: saveWebCamImage
  }), /*#__PURE__*/_react["default"].createElement(_ImageUploader.ChangePictureModalRow, null, /*#__PURE__*/_react["default"].createElement(_ImageUploader.ChangePictureModalColumn, null, /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
    onDrop: function onDrop(files) {
      if (files[0]) {
        setImageOversize(false);
        setFile(files[0]);
      }
    }
  }, function (_ref2) {
    var getRootProps = _ref2.getRootProps,
      getInputProps = _ref2.getInputProps;
    return /*#__PURE__*/_react["default"].createElement(_DocumentUploader.DropzoneContainer, (0, _extends2["default"])({}, getRootProps(), {
      width: "300px",
      onClick: _helpers.identity
    }), /*#__PURE__*/_react["default"].createElement(_DocumentUploader.DropzoneColumn, {
      style: {
        justifyContent: 'center',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      weight: "bold",
      style: {
        marginBottom: '8px',
        justifySelf: 'flex-start'
      }
    }, title), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, getInputProps(), {
      id: "uploadCameraModalInput",
      style: {
        display: 'none'
      },
      accept: ['.jpg', '.jpeg', '.png'].join(','),
      type: "file"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        position: 'relative',
        width: '100%'
      }
    }, fileSrc || s3Key || s3Bucket ? /*#__PURE__*/_react["default"].createElement("div", null, isErasable && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      dense: true,
      style: {
        position: 'absolute',
        top: '4px',
        right: '4px',
        color: '#333333',
        zIndex: 1
      },
      format: "round",
      size: "20",
      icon: "close",
      color: _theme.defaultTheme.color.danger["default"],
      onClick: removeImage
    }), fileSrc ? /*#__PURE__*/_react["default"].createElement(_ResponsiveImage.ResponsiveImage, {
      shouldZoom: true,
      src: fileSrc,
      aspectRatio: "135 / 76",
      containerStyle: {
        borderRadius: '10px'
      }
    }) : /*#__PURE__*/_react["default"].createElement(_ResponsiveImage.ResponsiveImage, {
      shouldZoom: true,
      s3Key: s3Key,
      s3Bucket: s3Bucket,
      aspectRatio: "135 / 76",
      containerStyle: {
        borderRadius: '10px'
      }
    })) : /*#__PURE__*/_react["default"].createElement(_ImageUploader.NoPhotoSelectedContainer, {
      imageOversize: imageOversize,
      theme: theme
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      size: "55",
      icon: "add-camera",
      style: {
        color: defaultTextColor
      }
    }), /*#__PURE__*/_react["default"].createElement(_DocumentUploader.FileName, {
      type: "small",
      style: {
        margin: '8px 0',
        color: defaultTextColor
      }
    }, imageOversize ? oversizeMessage : 'No file selected'))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      type: "small",
      style: {
        margin: '16px 0',
        textAlign: 'center'
      }
    }, "You can drag the picture from your computer here to upload it."), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      dense: true,
      icon: "upload",
      onClick: handleUploadFileButton
    }, "Upload Picture"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      type: "small",
      color: "#9E9E9E",
      style: {
        margin: '16px 0',
        fontSize: '12px'
      }
    }, helperText), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        width: '100%',
        marginBottom: '16px'
      }
    }, /*#__PURE__*/_react["default"].createElement(_ImageUploader.ImageUploaderDivider, null), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      type: "small",
      style: {
        margin: '0 4px'
      }
    }, "or"), /*#__PURE__*/_react["default"].createElement(_ImageUploader.ImageUploaderDivider, null)), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      dense: true,
      icon: "add-camera",
      onClick: function onClick() {
        return setWebCamImageModalVisibility(true);
      }
    }, "Take Picture from Camera")));
  })), fileSrc && croppedFileSrc && /*#__PURE__*/_react["default"].createElement(_ImageUploader.ChangePictureModalCropColumn, {
    style: {
      position: 'relative',
      minWidth: previewRender ? '700px' : '350px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_ImageUploader.ChangePictureModalRow, null, /*#__PURE__*/_react["default"].createElement(_ImageUploader.ChangePictureModalColumn, {
    style: {
      flex: 7
    }
  }, /*#__PURE__*/_react["default"].createElement(_ImageCropper.ImageCropper, {
    aspectRatio: format === 'round' ? 1 : 25 / 14,
    src: fileSrc,
    onCropFinished: function onCropFinished(cropped) {
      return setCroppedFile(cropped);
    }
  })), previewRender && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ImageUploader.ImageUploaderVerticalDivider, null), /*#__PURE__*/_react["default"].createElement(_ImageUploader.ChangePictureModalColumn, {
    style: {
      flex: 5
    }
  }, previewRender(croppedFileSrc)))))), /*#__PURE__*/_react["default"].createElement(_ImageUploader.ImageUploaderButtonsRow, {
    style: {
      flexDirection: 'row',
      justifyContent: fileSrc ? 'end' : 'center',
      marginTop: '8px'
    }
  }, (fileSrc || s3Key || s3Bucket) && isErasable && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    dense: true,
    icon: "close",
    themeColor: theme.color.danger,
    onClick: removeImage
  }, "Remove Image"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: !croppedFileSrc,
    dense: true,
    icon: "checkmark",
    themeColor: theme.color.success,
    onClick: completeUpload
  }, "Add Image")));
};
var _default = exports["default"] = ImageUploaderModal;